import {Component, Injector, OnInit, ViewEncapsulation} from '@angular/core';
import {UserService} from "./services/user.service";
import {DashboardService} from "./services/dashboard.service";
import {DateHelper} from "../../_helpers/date.helper";
import introJs from 'intro.js';
import {TOUR_DATA} from "./data/tour.data";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {UpcomingCeuAdvanceSearchDialog} from "./modals/upcoming-ceu-advance-search.dialog";
import {ParameterService} from "../../_services/parameter.service";
import {ProviderService} from "../../_services/provider.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {NotificationModal} from "./modals/notification.modal";

@Component({
    selector: 'user-dashboard',
    templateUrl: './user-dashboard.component.html',
    styleUrls: ['./user-dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UserDashboardComponent extends BasePageComponentDirective<any> implements OnInit {
    content: any;
    ceu: any;
    email?: string;
    roles: string[] = [];
    ceTypeParams: any = {};
    attendanceTypeParams: any = {};
    user: any;
    dateHelper = DateHelper;
    providers: any[] = [];
    scorecard = {
        individualChallenges: [] as any[],
        wideMatches: [] as any[],
        id: null as number
    };
    accountStatusCard = {
        product: '',
        expired: '',
        plan: '',
        planCount: 0,
        expirationDate: '',
    }
    numberOfCertCard = {
        count: 0,
        active: 0,
        expired: 0,
        dueSoon: 0,
        future: 0
    }
    notifications:any[] = [];
    reminders = {
        dueSoon: [] as any[],
        future: [] as any[],
        all: [] as any[]
    }
    upcomingCeuTraining: any[] = [];
    disabledButtons: boolean[] = [];
    filterTotal = 0;

    constructor(
        injector: Injector,
        private userService: UserService,
        private dashboardService: DashboardService,
        private parameterService: ParameterService,
        private providerService: ProviderService,
    ) {
        super(injector);
    }

    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['city', 'title', 'provider', 'ceType'];
        this.dashboardService.getUpcomingCEUs(this.pageQuery).then(r => {
            this.upcomingCeuTraining = r.content;
            this.disabledButtons = new Array(this.upcomingCeuTraining.length).fill(false);
            this.page.emit(r);

        });
    }

    countFilters(filters: any): number {
        let i = 0;
        if(filters.attendanceType) i++;
        if(filters.ceType) i++;
        if(filters.provider) i++
        if(filters.dateRange[0] > 0) i++
        return i;
    }

    clearFilters() {
        this.pageQuery.filters = { dateRange: ['0'] }
        this.searchTerm = this.pageQuery.search;
        this.filterTotal = this.countFilters(this.pageQuery.filters);
        this.query();
    }

    startTour() {
        const tour = introJs();
        tour.setOptions({
            steps: TOUR_DATA,
            showStepNumbers: false,
            nextLabel: 'Next &rarr;',
            prevLabel: '&larr; Previous',
            skipLabel: '&times;',
            doneLabel: 'Done',

        });

        let that = this;
        tour.oncomplete(function () {
            that.userService.setTourDone().then(r => {
                that.profileMsg.changeMessage(r);
                that.user = r;
                that.snackBar.open(`Congratulation ${that.user.fullName}! you are now ready to manage your certification`, null, {
                        duration: 5000, verticalPosition: 'top', horizontalPosition: 'right'
                    }
                )
            })
        });

        tour.start().then(); // Start the tour
    }

    viewDetailNotification(d: any) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '500px';
        const dialog = this.dialog.open(NotificationModal, {data: d, width: dialogWidth,
            maxWidth: '100%'}, );
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.userService.updateNotification(d.id).then(async r => {
                    this.notifications = await this.dashboardService.getNotifications();
                    this.snackBar.open('Notification marked as read', null, {
                            duration: 5000, verticalPosition: 'top', horizontalPosition: 'right'
                        }
                    )
                });
            }
        });
    }

    reloadTour() {
        setTimeout(() => {
            this.startTour();
        }, 1000);
    }

    openAdvanceSearch(): void {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '500px';
        const dialog = this.dialog.open(UpcomingCeuAdvanceSearchDialog, {
            data: {
                ceTypes: this.ceTypeParams.parameterMembers,
                attendanceTypes: this.attendanceTypeParams.parameterMembers,
                providers: this.providers,
                pageQuery: this.pageQuery
            },
            width: dialogWidth,
            maxWidth: '100%'
        });
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                r.pageQuery = undefined;
                this.pageQuery.filters = r;
                this.pageQuery.page = 0;
                this.filters = r;
                this.filterTotal = this.countFilters(this.pageQuery.filters);
                this.query();
            }
        });
    }

    searchCEU($event: any) {
        if ($event.key === 'Enter') {
            if(this.pageQuery.filters == null) {
                this.pageQuery.filters = { dateRange: ['0'] }
            } else {
                this.filterTotal = this.countFilters(this.pageQuery.filters);
            }
            this.searchTerm = this.pageQuery.search;
            this.query();
        }
    }

    override async ngOnInit(): Promise<void> {

        super.ngOnInit();
        this.profileMsg.currentMessage.subscribe(r => {
            if(r) {
                this.user = r;
                this.logic();
            } 
        })
    }

    async logic() {
        this.roles = this.user.roles;
        this.email = this.user.email;

        this.ceTypeParams = await this.parameterService.getParameterByName("CE_TYPE");
        this.attendanceTypeParams = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");
        this.providers = await this.providerService.getAllProvider();
        if(this.pageQuery.filters == null) {
            this.pageQuery.filters = { dateRange: ['0'] }
        }


        if(!this.user.tour) {
            setTimeout(() => {
                this.startTour();
            }, 2000)
        }

        this.query();

        this.dashboardService.getSubscription().then(r => {
            this.accountStatusCard = r;

            this.accountStatusCard.expirationDate = this.dateHelper.localeDate(this.accountStatusCard.expirationDate, 'id-ID');
            if(!this.accountStatusCard.product) {
                this.router.navigate(['/billing']);
            }
        });

        this.notifications = await this.dashboardService.getNotifications();

        this.dashboardService.getCountCertificates().then(r => {
            this.numberOfCertCard = r;
        });

        this.dashboardService.getReminders().then(r => {
            this.reminders = r;
        });

        this.dashboardService.getScorecardLatest().then(r => {
            this.scorecard = r;
        }, _ => {

        })

        this.userService.getUserInfo(this.email).then((data: any) => {
                this.ceu = data.certMetaData;
        },(err: any) => {
                if (err.status == 404) {
                    this.router.navigate(['/login']).then(_ => {
                        localStorage.clear();
                        this.snackBar.open('Certwallet member was not found.. logging out!', null, {duration: 5000, verticalPosition: 'top', horizontalPosition: 'end'});
                    });

                }
            });
    }

    enroll(d: any, index: number) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '500px';
        const dialog = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: `Are you sure want to enroll certification ${d.title}  by ${d.provider}?`,
                subMessage: 'We will send you an email later for further enrollment process',
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'Yes, Enroll Me'
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.userService.enrollMe(d.id).then(_ => {
                    this.showAlert('Enroll CEU', 'Your enrollment request has been sent to CertWallet Admin successfully', '');
                    this.disabledButtons[index] = true;
                })
            }
        })

    }

    goToDetail(id: number) {
        this.router.navigate([`my-wallet/scorecard/${id}/view`]).then();
    }
}
